import { createContext, useEffect, useState } from 'react'

export const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en')

  useEffect(() => {
    // Automatische Auswahl: Deutsch, wenn Browser auf "de" steht, sonst Englisch
    const lang = navigator.language || navigator.userLanguage
    setLanguage(lang && lang.startsWith('de') ? 'de' : 'en')
  }, [])

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}
